export default __webpack_public_path__ + "static/media/check.cc53c997.svg";